"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Summary_1 = __importDefault(require("../models/Summary"));
class SummaryService {
    constructor() {
        this.data = new Summary_1.default();
        this.isErrorPage = false;
        this.errorCode = 0;
        this.errorMessage = '';
        this.isLoading = false;
    }
    async call(token) {
        await this.fetch(token);
    }
    async fetch(token) {
        this.isLoading = true;
        try {
            const request = await fetch(`/trials/api/summary/${token}`);
            const response = await request.json();
            if (response.status) {
                this.isErrorPage = true;
                this.errorCode = response.status;
                this.errorMessage = response.message;
            }
            else {
                this.data = new Summary_1.default(response);
            }
        }
        catch (error) {
            console.log(error);
        }
        this.isLoading = false;
    }
}
exports.default = SummaryService;
